import { render, staticRenderFns } from "./_taskResellerWarning.vue?vue&type=template&id=f176c182"
import script from "./_taskResellerWarning.vue?vue&type=script&lang=js"
export * from "./_taskResellerWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports